import React, { useEffect, useState, useContext } from "react";
import { GlobalContext } from "../../Contexts/GlobalContext";
import { Container } from "./styled";
import { Link } from "react-router-dom";

const SearchInput = ({ appData }) => {
  const [query, setQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const { globalData, setGlobalData } = useContext(GlobalContext);

  // 🔥 Normaliza acentos (José → jose)
  const normalizeText = (str) =>
    str
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  useEffect(() => {
    if (
      globalData &&
      globalData.players !== null &&
      globalData.teams !== null
    ) {
      const combinedData = [
        ...globalData?.players.map((player) => ({
          name: player.player_name,
          lastname: player.player_lastname,
          type: "player",
          id: player._id,
        })),
        ...globalData?.teams.map((team) => ({
          name: team.name,
          type: "team",
          id: team._id,
        })),
      ];
      setFilteredData(combinedData);
      setCombinedData(combinedData);
    }
  }, [globalData, globalData.players, globalData.teams]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setQuery(value);

    if (value === "") {
      setFilteredData(combinedData);
    } else {
      const normalizedValue = normalizeText(value);

      const filtered = combinedData.filter((item) => {
        const name = normalizeText(item.name);
        const lastname = normalizeText(item.lastname || "");

        return (
          name.includes(normalizedValue) || lastname.includes(normalizedValue)
        );
      });

      setFilteredData(filtered);
    }
  };

  return (
    <Container style={{ background: "white" }}>
      <input
        type="text"
        value={query}
        onChange={handleInputChange}
        placeholder="Search..."
      />
      <div className={`popupContainer ${query !== "" ? "active" : null}`}>
        <ul>
          {query !== "" &&
            filteredData.length > 0 &&
            filteredData?.map((item, index) => (
              <Link
                key={index}
                to={`/${
                  item.type === "team" ? "teamProfile" : "statsProfile"
                }/${item.id}`}
                onClick={() => setQuery("")}
              >
                <li>
                  {item.name} {item.lastname}
                </li>
              </Link>
            ))}

          {query !== "" && filteredData.length === 0 ? (
            <p>No hay resultados</p>
          ) : null}
        </ul>
      </div>
    </Container>
  );
};

export default SearchInput;
